// Główny kontener dla interfejsu noclegów na pełny ekran

import React from "react";
import type { MarkupSettings } from "../../utils/markupCalculations";
import {
  AccommodationProvider,
  useAccommodation,
} from "./AccommodationProvider";
import ControlPanel from "./components/ControlPanel/ControlPanel";
import AvailableRoomsPanel from "./components/AvailableRooms/AvailableRoomsPanel";
import AssignedRoomsPanel from "./components/AssignedRooms/AssignedRoomsPanel";
import { AccommodationDetailSection } from "./components/AccommodationDetail/AccommodationDetailSection";

interface AccommodationFullscreenProps {
  offerId: string;
  initialData?: {
    accommodationDays?: any[];
    guestStructure?: {
      pairs: number;
      singles: number;
      singlesAlone: number;
    };
    markup?: MarkupSettings;
  };
  onOfferDaysChanged?: (offerDays: any[]) => void;
}

// Główny komponent interfejsu (wewnątrz Provider)
const AccommodationFullscreenContent: React.FC = () => {
  const {
    isLoading,
    availabilityData,
    // guestStructure,
    // assignedGuests,
    // assignedRooms,
    // currentDayIndex,
    // addToAllDays,
    // viewMode,
    // displayOptions,
  } = useAccommodation();

  return (
    <div className="min-h-screen bg-neutral-50 w-full">
      {/* Layout na pełną szerokość */}
      <div className="w-full px-4 py-6">
        {/* Loading State */}
        {isLoading && (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-neutral-600">Ładowanie danych...</span>
          </div>
        )}

        {/* Panel kontrolny */}
        <ControlPanel />

        {/* Główny layout - dostępne i przypisane pokoje */}
        <div className="grid grid-cols-1 gap-6">
          <div className="grid grid-cols-1 lg:grid-cols-10 gap-6">
            <div className="lg:col-span-6">
              <AvailableRoomsPanel />
            </div>

            <div className="lg:col-span-4">
              <AssignedRoomsPanel />
            </div>
          </div>

          {/* Sekcja szczegółów noclegów - collapsible, na dole */}
          <AccommodationDetailSection />
        </div>

        {/* Error State */}
        {!isLoading && !availabilityData && (
          <div className="text-center py-8">
            <div className="text-red-600 mb-2">⚠️</div>
            <p className="text-neutral-600">
              Nie udało się załadować danych dostępności pokoi.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

// Główny komponent z Provider
const AccommodationFullscreen: React.FC<AccommodationFullscreenProps> = ({
  offerId,
  initialData,
  onOfferDaysChanged,
}) => {
  return (
    <AccommodationProvider offerId={offerId} initialData={initialData} onOfferDaysChanged={onOfferDaysChanged}>
      <AccommodationFullscreenContent />
    </AccommodationProvider>
  );
};

export default AccommodationFullscreen;
